import { create } from 'vue-modal-dialogs'
import AppDialog from '@/components/ui/AppDialog'

export function getDialog (...props) {
  return create(AppDialog, ...props)
}
